var common = require('./common');

function tunnel_save_data (json_data) {
  $.ajax({
    url: '/tunnel-adhesion/save/data',
    data: {data:{json_data}},
    method: 'post',
    cache: false,
    dataType: 'json',
    success: function (data) { 
      console.log(data);
      
    },
    error: function (XMLHttpRequest, textStatus, errorThrown)
    {
      if ( errorThrown != 'abort' )
      {
        console.log(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
      }
    }
  })
}
jQuery(function($) {
  // Fields form
  var fields = [
    'form-address-name',
    'form-address-company',
    'form-address-tva',
    'form-address-civility',
    'form-address-lastname',
    'form-address-firstname',
    'form-address-address1',
    // 'form-address-address2',
    'form-address-cp',
    'form-address-city',
    'form-address-country',
  ]
  //

  var modifyCart = function(pid, type, uds)
  {
    var url = '/cart/update/product/' + pid + '/' + uds + '/' + type
    var requestXHr = $.ajax({
      url: url,
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data )
        {
          $('#header-tools__count').html(data.count)
          if ( data.count == 0 )
          {
            $('#cartpage-cart-body').html(data.body)
          }
          else
          {
            $('#cartpage-cart-packaging').html(data.packaging)
            $('#cartpage-cart-totals').html(data.totals)
          }
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  }

  var removeAddress = function(id)
  {
    var url = '/address/remove/' +  id
    var requestXHr = $.ajax({
      url: url,
      cache: false,
      dataType: 'json',
      success: function (data) { },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  }

  var updateAddressHtml = function(id, tunnel, uid)
  {
    sessionStorage.setItem('SMF.Address.Save', id)
    var request = $.ajax({
      url: '/address/form', //drupalSettings.path.pathPrefix
      data: {
        aid   : id,
        tunnel: tunnel,
        uid   : uid,
      },
      method: 'post',
      cache: false,
      dateType: 'html',
      success: function (data)
      {
        $('#modal-html-update-address').html(data.result)
        $('#update-address-modal').modal('show')
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  }

  var updateMesCoordonneesPage = function()
  {
    var request = $.ajax({
      url: window.location.pathname,
      method: 'get',
      cache: false,
      dateType: 'html',
      success: function (data)
      {
        $('#rows-billing').html($(data).find('#rows-billing').html())
        $('#rows-shipping').html($(data).find('#rows-shipping').html())
        $('#rows-main-address').html($(data).find('#rows-main-address').html())

        sessionStorage.removeItem('SMF.Address.Save')
        sessionStorage.removeItem('SMF.Address.Save.Type')
        $('#update-address-modal').modal('hide')
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  }

  var showModalUpdateSubscriptions = function(data)
  {
    common.globalLoader(true);
    var request = $.ajax({
      url: '/subscriptions/form',
      data: data,
      method: 'post',
      cache: false,
      dateType: 'html',
      success: function (data)
      {
        $('#update-address-modal').modal('hide');
        if ( data.result != '' )
        {
          $('#modal-html-update-subscriptions').html(data.result);
          $('#update-subscriptions-modal').modal('show');
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        common.globalLoader(false);
      }
    });
  }

  var showModalUpdateSubscriptionsByAddress = function(sid)
  {
    if ( sid != '' )
    {
      common.globalLoader(true);
      var request = $.ajax({
        url: '/subscriptions/form-by-address',
        data: {
          sid: sid
        },
        method: 'post',
        cache: false,
        dateType: 'html',
        success: function (data)
        {
          if ( data.result != '' )
          {
            $('#modal-html-update-subscriptions-by-address').html(data.result);
            $('#update-subscriptions-by-address-modal').modal('show');
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false);
        }
      });
    }
  }

  var updateSubscriptionsByAddress = function()
  {
    common.globalLoader(true);
    $('#update-subscriptions-by-address-modal').modal('hide');
    var subscription_list_address = $('input[name="subscription_list_address"]').val();
    var request = $.ajax({
      url: '/subscriptions/update/cart',
      data: {
        form   : [
          {
            name: 'subscription_list_checkbox_' + subscription_list_address,
            value: $('input[name="subscription_list_address"]').val(),
          },
          {
            name: 'subscription_list_address',
            value: $('input[name="subscription_address_list"]:checked').val()
          }
        ]
      },
      method: 'post',
      cache: false,
      dateType: 'html',
      success: function (data) {
        $('#update-subscriptions-by-address-msg').modal('show');
        var request = jQuery.ajax({
          url: '/smf_admin/abonnements/get-address',
          data: {
            path: subscription_list_address
          },
          method: 'post',
          cache: false,
          success: function (data) {
            if ( data.html != '' )
            {
              $('.collapse-address-order-' + data.id).html(data.html);
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown)
          {
            if ( errorThrown != 'abort' )
            {
              console.log(XMLHttpRequest);
              console.log(textStatus);
              console.log(errorThrown);
            }
          }
        });
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        common.globalLoader(false);
      }
    });
  }

  var updateSubscriptions = function()
  {
    $('#update-subscriptions-modal').modal('hide');

    if ( $('#subscription_list').serializeArray().length > 1 )
    {
      common.globalLoader(true);
      var request = $.ajax({
        url: '/subscriptions/update/cart',
        data: {
          form   : $('#subscription_list').serializeArray(),
          address: $('#subscription_address').val(),
        },
        method: 'post',
        cache: false,
        dateType: 'html',
        success: function (data) {
          $('#update-subscriptions-modal-msg').modal('show');
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false);
        }
      });
    }
  }

  var userLogged = function()
  {
    if ( drupalSettings.user.uid == 0 )
    {
      return false
    }
    else
    {
      return true
    }
  }

  var userLogged = userLogged()

  $('body').on('click', '.cart-controls .cart-controls-subtract', function(e) {
    e.preventDefault()
    var value = parseInt($('.cart-controls .cart-controls-qty[data-id="' + $(this).data('id') + '"]').val(), 10)
    value     = isNaN(value) ? 0 : value
    if ( value > 1 )
    {
      value--
      $('.cart-controls .cart-controls-qty[data-id="' + $(this).data('id') + '"]').val(value)
    }
    if ( $(this).hasClass('do-ajax') )
    {
      modifyCart($(this).data('pid'), $(this).data('type'), value)
    }

    common.dataLayerPush({
      'event'      : 'GAEvent',
      'eventAction': 'Click',
      'eventLabel' : 'Diminution de la quantité de produit',
      'eventValue' : value,
      'eventPage'  : window.location.href
    })
  })

  $('body').on('click', '.cart-controls .cart-controls-add', function(e) {
    e.preventDefault()
    var value = parseInt($('.cart-controls .cart-controls-qty[data-id="' + $(this).data('id') + '"]').val(), 10)
    value     = isNaN(value) ? 0 : value
    if ( value < 1000 )
    {
      value++
      $('.cart-controls .cart-controls-qty[data-id="' + $(this).data('id') + '"]').val(value)
    }
    if ( $(this).hasClass('do-ajax') )
    {
      modifyCart($(this).data('pid'), $(this).data('type'), value)
    }

    common.dataLayerPush({
      'event'      : 'GAEvent',
      'eventAction': 'Click',
      'eventLabel' : 'Augmenter la quantité de produit',
      'eventValue' : value,
      'eventPage'  : window.location.href
    })
  })

  $('body').on('click', '.cart-controls-delete', function(e) {
    e.preventDefault()
    var $this   = $(this)
    var $target = $('#product-' + $this.data('pid') + '-' + $this.data('type'))
    $target.fadeOut('slow', function(){
      modifyCart($this.data('pid'), $this.data('type'), 0)
      $target.remove()
    })
  })

  $('body').on('click', '.btn-add-to-cart', function(e) {
    e.preventDefault()
    if ( userLogged )
    {
      var $el = $(this)
      var fields  = $('#form-add-product-' + $(this).data('pid') + '-' + $(this).data('type')).serializeArray();
      var request = $.ajax({
        url: '/cart/add/product/' + $(this).data('pid') + '/' + fields[0].value + '/' + $(this).data('type'),
        cache: false,
        success: function (data)
        {
          var list = ''
          if ( $el.data('list') )
          {
            list = '-' + $el.data('list')
          }

          $('#add_to_cart_modal-ul--price-ad .p1').html($el.data('pricead'));
          $('#add_to_cart_modal-ul--price-ad .p2').html($el.data('priceadold'));
          $('#add_to_cart_modal-ul--price-noad .p1').html($el.data('pricenoad'));
          $('#add_to_cart_modal-ul--price-noad .p2').html($el.data('pricenoadold'));

          $('#add-to-cart-modal' + list).css({
            'top': '50%',
            'margin-top': function() { return -$(this).outerHeight()/2 }
          })
          $('#add-to-cart-modal' + list).modal('show')
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
    else
    {
      $('#please-login-modal').css({
        'top': '50%',
        'margin-top': function() { return -$(this).outerHeight()/2 }
      })
      $('#please-login-modal').modal('show')
    }
  })

  $('body').on('change', '.radio-address[name="radio-livraison"]', function() {
    var url = '/cart/update/shipping/' + this.value
    var requestXHr = $.ajax({
      url: url,
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data)
        {
          $('#cartpage-cart-totals').html(data.totals)
        } 
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  })

  $('body').on('click', '.btn-goto-payment', function(e) {
    e.preventDefault()
    var error = false
    var href = $(this).attr('href')
    if ( $('input[name=radio-facturation]:checked').val() == undefined )
    {
      error = true
    }
    if ( $('input[name=radio-livraison]:checked').val() == undefined )
    {
      error = true
    }
    if ( error )
    {
      $.notify({
        message: Drupal.t('Vous devez sélectionner une adresse de livraison et de facturation.')
      },{
        z_index: 2000,
        allow_dismiss: false,
        type: 'danger'
      })
    }
    else
    {
      var request = $.ajax({
        url: '/cart/save/shipping',
        data: {
          billing: $('input[name=radio-facturation]:checked').val(),
          shipping: $('input[name=radio-livraison]:checked').val()
        },
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( data.response === true )
          {
            $.notify({
              message: Drupal.t("L'une des adresses sélectionnées est incorrecte.")
            },{
              z_index: 2000,
              allow_dismiss: false,
              type: 'danger'
            })
          }
          else
          {
            window.location.href = href
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
  })

  /*$('body').on('click', '.btn-remove-address', function(e) {
    e.preventDefault()

    sessionStorage.setItem('SMF.Address.Remove', $(this).data('id'))

    $('#remove-address-modal').css({
      'top': '50%',
      'margin-top': function() { return -$(this).outerHeight()/2 }
    })
    $('#remove-address-modal').modal('show')
  })*/

  /*$('body').on('click', '.remove_address_modal-btn-ok', function(e) {
    e.preventDefault()

    var $target = $('#address-row-' + sessionStorage.getItem('SMF.Address.Remove'))

    $target.fadeOut('slow', function() {
      removeAddress(sessionStorage.getItem('SMF.Address.Remove'))
      sessionStorage.removeItem('SMF.Address.Remove')
      $('#remove-address-modal').modal('hide')
      $target.remove()
    })
  })*/

  $('body').on('click', '.btn-add-address', function(e) {
    e.preventDefault()
    sessionStorage.setItem('SMF.Address.Save.Type', $(this).data('type'))
    updateAddressHtml('', $(this).data('tunnel'), $(this).data('uid'))
  })

  $('body').on('click', '.btn-update-address', function(e) {
    e.preventDefault()
    sessionStorage.setItem('SMF.Address.Save.Type', '')
    updateAddressHtml($(this).data('id'), $(this).data('tunnel'), '')
  })

  var btn_blocked = false
  $('body').on('click', '.btn-finish-payment', function(e) {
    e.preventDefault()

    if ( !btn_blocked )
    {
      var error      = false

      if ( $('input[name=radio-payment]:checked').val() == undefined )
      {
        error = true
      }

      if ( error )
      {
        $.notify({
          message: Drupal.t('Vous devez sélectionner une méthode de paiement.')
        },{
          z_index: 2000,
          allow_dismiss: false,
          type: 'danger'
        })
      }
      else
      {
        btn_blocked = true
        common.globalLoader(true)
        common.requestPaymentCheckout($('input[name=radio-payment]:checked').val(), 'cart')
      }
    }
  })

  // Form actions
  $('body').on('change', 'select[name="form-address-type"]', function() {
    var form = $(this).closest('form')

    if ( $(this).val() == 'individual' )
    {
      $('#' + form.attr('id') + ' .only-company').addClass('hide')
    }
    else if ( $(this).val() == 'company' || $(this).val() == 'company2' )
    {
      $('#' + form.attr('id') + ' .only-company').removeClass('hide')
    }
  })

  // Form validation
  $('body').on('click', '.update_address_modal-btn-ok', function(e) {
    e.preventDefault();
    var form   = '#form-address'
    var type   = $(form + ' select[name="form-address-type"]').val()
    var error  = common.validateForm(type, form, fields)
    var tunnel = $(this).data('tunnel')
    var uid    = $(this).data('uid')

    if ( !error )
    {
      common.globalLoader(true);
      var url = '/address/save'
      var requestXHr = $.ajax({
        url: url,
        data: {
          aid : sessionStorage.getItem('SMF.Address.Save'),
          form: $(form).serializeArray(),
          type: sessionStorage.getItem('SMF.Address.Save.Type'),
          uid : uid
        },
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( tunnel == 'adhesion' )
          {
            var result = searchAddress(data.uid, data.type_address) // from adhesion.js
            $('#update-address-modal').modal('hide')
          }
          else
          {
            var result = updateMesCoordonneesPage();
            if ( data.type_address == 'shipping' ) // && data.operation == 'new'
            {
              var result = showModalUpdateSubscriptions(data);
            }
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false);
        }
      })
    }
  })

  // Form user address adhésion
  if ( $('#checkbox-yearbook').length > 0 )
  {
    $('#checkbox-yearbook').on('click', function()
    {
      if ( $(this).is(':checked') )
      {
        $('#div-yearbook').removeClass('hide')
      }
      else
      {
        $('#div-yearbook').addClass('hide')
      }
    })
  }

  // Update subscriptions
  $('body').on('click', '.update_subscriptions_modal-btn-ok', function(e) {
    e.preventDefault();
    updateSubscriptions();
  });

  // Update subscripts : show addresses
  $('body').on('click', '.btn-show-modal-update-subscriptions-by-address', function(e) {
    e.preventDefault();
    showModalUpdateSubscriptionsByAddress($(this).data('id'));
  });

  $('body').on('click', '.update_subscriptions_by_address_modal-btn-ok', function(e) {
    e.preventDefault();
    updateSubscriptionsByAddress();
  });
  
  $('#client-tunnel-adhesion-shipping-container').on('click','.addresspage_block__radio', function(e) {
    
    var address_nid=e.target.value;    

    if(address_nid) {
  
        tunnel_save_data({'shipping_address':address_nid,'billing_address':address_nid});  
    }
    
  });

  $('#client-tunnel-adhesion-billing-container').on('click','.addresspage_block__radio', function(e) {
    
    var address_nid=e.target.value;
    
    if(address_nid ) {
      
        tunnel_save_data({'billing_address':address_nid});
    }
    
  });
})


// WEBPACK FOOTER //
// ./js/tunnel.js